<template>
  <div class="whole">
    <div class="breadcrumbs flex ai">
      <div @click="router.push('/')" class="breadcrumbs-txt pointer">主页</div>
      <img class="iconArrow" src="@/assets/iconArrow.png" alt="" />
      <div v-if="product[typeIndex].name == '专业营养'" class="breadcrumbs-txt1 default">专业营养 Professional Nutrition</div>
      <div v-if="product[typeIndex].name == '基础营养'" class="breadcrumbs-txt1 default">基础营养 Complete Multivitamin</div>
      <div v-if="product[typeIndex].name == '果味营养'" class="breadcrumbs-txt1 default">果味营养 Natural Fruit Bites
        Multivitamin</div>
    </div>
    <div class="main-content flex column jcs">
      <div>
        <!-- <img class="banner" :src="require(`@/assets/product/${product[typeIndex].imgUrl}Banner.png`)" alt="" /> -->
        <div v-if="product[typeIndex].name == '专业营养'" class="bannerBox1 flex jcc">
          <div style="width: 1371px">
            <img class="ScienceThatMatters1" src="@/assets/product/specialtyBannerTxt.png" alt="" />
          </div>
        </div>
        <div v-if="product[typeIndex].name == '基础营养'" class="bannerBox2 flex jcc">
          <div style="width: 1371px">
            <img class="ScienceThatMatters2" src="@/assets/product/basicsBannerTxt.png" alt="" />
          </div>
        </div>
        <div v-if="product[typeIndex].name == '果味营养'" class="bannerBox3 flex jcc">
          <div style="width: 1371px">
            <img class="ScienceThatMatters3" src="@/assets/product/fruityBannerTxt.png" alt="" />
          </div>
        </div>
        <div class="flex jcc">
          <div v-if="product[typeIndex].name == '专业营养' || product[typeIndex].name == '果味营养'" class="product-box flex">
            <div @click="enterProductDetails(product[typeIndex].productList[index - 1].name)"
              class="product-imgBox flex jcc" v-for="index in product[typeIndex].productList.length" :key="index">
              <img class="product-img" :src="require(`@/assets/product/${product[typeIndex].imgUrl}${index}.png`)"
                alt="" />
              <!-- <img class="product-img-hover"
                :src="require(`@/assets/product/${product[typeIndex].imgUrl}Img${index}.png`)" alt="" /> -->
            </div>
          </div>
          <div v-if="product[typeIndex].name == '基础营养'" class="product-box flex">
            <div @click="enterProductDetails(product[typeIndex].productList[index - 1].name)"
              class="product-imgBox flex jcc" v-for="index in product[typeIndex].productList.length" :key="index">
              <img class="product-img" :src="require(`@/assets/product/${product[typeIndex].imgUrl}${index}.png`)"
                alt="" />
              <img class="product-img-hover"
                :src="require(`@/assets/product/${product[typeIndex].imgUrl}Img${index}.png`)" alt="" />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import Footer from "../../components/Footer.vue";
import { useRouter, useRoute } from "vue-router";
import product from "@/utils/product.json";
const route = useRoute();
const router = useRouter();
// 产品类型
var type = ref("");
var typeIndex = ref(null);
// 获取数据的函数
async function fetchData(params) {
  // 根据参数获取数据
  type.value = params.type;
  typeIndex.value = product.findIndex((item) => item.name === type.value);
}

// 初始化加载
fetchData(route.query);
// 监听路由变化
watch(
  () => route.query,
  (newQuery) => {
    fetchData(newQuery);
  },
  { deep: true }
);
// 进入产品详情
const enterProductDetails = (name) => {
  console.log(name);
  return;
  router.push({ name: "ProductDetails", query: { name: name } });
};
</script>

<style src="./product.css" scoped></style>
